<template>
  <div class="customizer-summary-tab flex-container collapse-s">
    <div class="review">
      <div class="review-content">
        <template v-for="option in selectedOptions">
          <template v-if="option.optionCode">
            <div class="review-item" v-if="!option.selected || (option.selected && !option.noteRequired)">
              <h4 class="name">{{ option.groupName == 'Digital Proof Via Email' ? 'Digital Proof' : option.groupName }}:</h4>
              <span class="value secondary-font">{{ option.name | handleBoolean }}</span>
            </div><!-- /.review-item -->

            <div class="review-item full" v-else>
              <h4 class="name">{{ option.groupName }}</h4>

              <span class="value secondary-font">{{ option.notes }}</span>
            </div><!-- /.review-item -->
          </template>
        </template>

        <div class="review-item full" v-if="notes">
          <h4 class="name">STANDARD PRODUCTION TIMES</h4>
          <span class="value secondary-font" v-html="notes"></span>
        </div><!-- /.review-item -->

        <div class="review-actions">
          <button class="btn is-primary" @click="gotoEditor">Edit Customization</button>
        </div><!-- /.review-actions -->
      </div><!-- /.review-content -->
    </div><!-- /.review -->

    <div class="previewer">
      <div class="previewer-content flex-container is-vertical">
        <div class="arranger flex">
          <div class="photo-wrap" :class="selectedOrientation">
            <img :src="currentCroppieImage">
          </div>
        </div>
        <bottom-bar></bottom-bar>
      </div><!-- /.flex-container -->
    </div><!-- /.review -->

    <div class="show-mobile mobile-bottom-bar">
      <bottom-bar></bottom-bar>
    </div><!-- /.mobile-bottom-bar -->
  </div><!-- /.customizer-summary-tab -->
</template>

<script>
import BottomBar from '@/components/review/BottomBar'
import { mapActions, mapState } from "vuex"

export default {
  name: "SummaryTab",
  components: {
    BottomBar
  },
  computed: {
    ...mapState([
      "selectedOptions",
      "currentCroppieImage",
      "selectedOrientation",
      "notes"
    ]),
  },
  filters: {
    // Translate true/false to Yes/No
    handleBoolean: function(value) {
      return value === true ? "Yes" : value === false ? "No" : value;
    },
  },
  methods: {
    ...mapActions(["set"]),
    gotoEditor() {
      this.set({
        var: "selectedTab",
        val: 0
      })
    }
  }
}
</script>
